const setupHeaderSearch = () => {
  const searchFields = document.querySelectorAll(".search-field");
  for (let index = 0; index < searchFields.length; index++) {
    console.log(searchFields[index].value);
    searchFields[index].value = "";
  }

  const searchBtn = document.querySelectorAll(".search__submit");

  for (let index = 0; index < searchBtn.length; index++) {
    searchBtn[index].addEventListener("click", (e) => {
      e.preventDefault();
      const parent = e.target.closest(".search__submit-wrap");
      parent.querySelector(".search-submit").click();
    });
  }
};

export default setupHeaderSearch;
